module.exports = __webpack_public_path__ + "img/Union.2c94dc51.png";